import 'bootstrap/dist/css/bootstrap.min.css';
import ModalCore from 'components/Modal/Core';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CoreState } from './context/CoreContext';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './router'; // MOD

ReactDOM.render(
  <StrictMode>
    <CoreState>
      <App />
      <ModalCore />
      <ToastContainer />
    </CoreState>
  </StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
